/*
* @Author: 王春岩 <Bolt>
* @Date:   2017-05-16 14:12:56
* @Last Modified by:   Bolt
* @Last Modified time: 2017-05-16 14:53:24
*/

'use strict';

import stores, { VueParent } from 'babel-loader!./stores.babel.js';

export class Layer {
    constructor(name) {
        this.name = name || 'default';
        let Vue = VueParent.Vue;
        this.storeData = new Vue({
            data: {
                list: [],
                forbidScroll: false
            }
        });
    }

    init() {
        return (component, attributes, children) => {
            stores[this.name].storeData.forbidScroll = true;
            stores[this.name].storeData.list.push({
                component,
                attributes,
                children
            });
        };
    }
}



// WEBPACK FOOTER //
// ./~/@souche-f2e/weidian-util-vue-layer/src/Layer.babel.js